import styled from "styled-components";

const StyledHero = styled.div` 
    margin: 1rem;
    text-align: center;

    section {

    }

    h1 {
        color: rgba(6, 214, 160, 1);
        margin-bottom: 1rem;
        margin-top: 70px;
        font-size: 50px;
    }

    h3, p {
        margin-bottom: 1rem;
        text-align: justify;
    }


    .hero__image{
        max-width: 90%;
        justify-content: right;
        margin-top: 70px;
}

    /* Large Screen */
@media (min-width: 992px) {
    .container{
        text-align: left;
        max-width: 1200px;
        margin: 0 auto;
    }


    .hero{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;  
    }

    
    .hero__image{
        max-width: 90%;
        justify-content: center;
        margin-top: 70px;
    }

    .hero__left{
        flex-basis: 40%;
        padding: 25px;
        justify-content: center;
    }

    .hero__right{
        flex-basis: 50%;
        justify-content: right;
    }
}


`;

export default StyledHero;